<script>
    import Error from '/srv/web/wyvr/html/releases/58819/gen/client/shop/messages/Error.svelte?1733898724806';
    import Info from '/srv/web/wyvr/html/releases/58819/gen/client/shop/messages/Info.svelte?1733898724806';
    import Success from '/srv/web/wyvr/html/releases/58819/gen/client/shop/messages/Success.svelte?1733898724806';
    import Warning from '/srv/web/wyvr/html/releases/58819/gen/client/shop/messages/Warning.svelte?1733898724806';
    import { messages } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/messages.js?1733898724806';

    export let message;

    function close() {
        messages.close(message.id);
    }

    $: show = !(message.type === 'success' && message.message.match(/Artikel "[^"]*" zum Warenkorb hinzugefügt/));
</script>

{#if show}
    <div data-message-id={message.id}>
        {#if message.type == 'info'}
            <Info {message} />
        {:else if message.type == 'warning'}
            <Warning {message} />
        {:else if message.type == 'error'}
            <Error {message} />
        {:else if message.type == 'success'}
            <Success {message} />
        {/if}
    </div>
{/if}


<style>
    div {
        position: relative;
        margin-bottom: 1px;
    }
</style>